import React, { Component } from 'react'
import { Layout } from 'antd'
import { Route, Switch, Redirect } from 'react-router-dom'
import { userIsAuthenticatedRedir, userIsNotAuthenticatedRedir } from '../security/Auth'
import ErrorBoundary from '../components/ErrorBoundary'
import Analytics from '../components/Analytics'
import Loadable from 'react-loadable'
import Home from '../components/home'
import NavBar from '../components/layout/NavBar'
import LoadingComponent from '../components/LoadingComponent'
import UserService from '../services/UserService'
import { connect } from 'react-redux'
import { login } from '../actions/UserActions'
import store from '../store/configureStore'
import LogrocketConfig from '../utils/LogrocketConfig'

const BookingContainer = Loadable({
  loader: () => import('./BookingContainer'),
  loading: LoadingComponent
})

const Profile = Loadable({
  loader: () => import('../components/profile'),
  loading: LoadingComponent
})
const ServicePage = Loadable({
  loader: () => import('../components/servicepage'),
  loading: LoadingComponent
})
const FAQ = Loadable({
  loader: () => import('../components/faq'),
  loading: LoadingComponent
})
const About = Loadable({
  loader: () => import('../components/about'),
  loading: LoadingComponent
})
const Privacy = Loadable({
  loader: () => import('../components/Privacy'),
  loading: LoadingComponent
})
const Terms = Loadable({
  loader: () => import('../components/Terms'),
  loading: LoadingComponent
})
const Footer = Loadable({
  loader: () => import('../components/layout/Footer'),
  loading() {
    return null
  }
})
const ResetPassword = Loadable({
  loader: () => import('../components/login/ResetPassword'),
  loading: LoadingComponent
})
const BookingReceipt = Loadable({
  loader: () => import('../components/booking/BookingReceipt'),
  loading: LoadingComponent
})
const ProfileUpdateSuccess = Loadable({
  loader: () => import('../components/profile/ProfileUpdateSuccess'),
  loading: LoadingComponent
})
const LoginPage = Loadable({
  loader: () => import('../components/login/LoginPage'),
  loading: LoadingComponent
})

const CarsWeServicePage = Loadable({
  loader: () => import('../components/seo/CarsWeService'),
  loading: LoadingComponent
})
const CitiesWeServePage = Loadable({
  loader: () => import('../components/seo/CitiesWeServe'),
  loading: LoadingComponent
})
const { Header, Content } = Layout

class AppContainer extends Component {
  componentDidMount() {
    LogrocketConfig.init()
    this.getUserData()
  }

  async getUserData() {
    //await UserService.getCsrfToken()
    const response = await UserService.loginUsingCookie()
    if (response) {
      store.dispatch(login(response))
    }
  }

  render() {
    return (
      <ErrorBoundary>
        {Analytics.init() && <Analytics.RouteTracker />}
        <Layout className="automech-layout">
          <Header>
            <NavBar />
          </Header>
          <Content>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/service" component={ServicePage} />
              <Route exact path="/faq" component={FAQ} />
              <Route exact path="/about" component={About} />
              <Route exact path="/privacy" component={Privacy} />
              <Route exact path="/terms" component={Terms} />
              <Route path="/cars" component={CarsWeServicePage} />
              <Route path="/cities" component={CitiesWeServePage} />
              <Route
                path="/profile"
                component={userIsAuthenticatedRedir(Profile)}
                //component={Profile}
              />
              <Route exact path="/login" component={userIsNotAuthenticatedRedir(LoginPage)} />
              <Route path="/booking" component={BookingContainer} />
              <Route path="/thankyou" component={BookingReceipt} />
              <Route path="/profileupdated" component={ProfileUpdateSuccess} />
              <Route path="/reset/:token" component={ResetPassword} />
              <Redirect to="/" />
            </Switch>
          </Content>
          <Footer />
        </Layout>
      </ErrorBoundary>
    )
  }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js